import { PropTypes } from "prop-types";

import { CONTINUE_STEP } from "../helpers/constants";
import { useCompanyInfo } from "../hooks/useCompanyInfo";
import { usePathname } from "../hooks/usePathname";
import { Container } from "./Container";
import { MovingAssistance } from "./MovingAssistance";

export const PostFormLayout = ({ children }) => {
	const { companyName } = useCompanyInfo();
	const pathname = usePathname();
	const isContinueStep = pathname === CONTINUE_STEP;

	return (
		<Container
			as="main"
			className="tw:flex tw:h-full tw:w-full tw:flex-col tw:justify-end tw:gap-4 tw:pt-8 tw:pb-[28px] tw:md:gap-6 tw:md:pb-10 tw:lg:flex-row tw:lg:gap-[30px] tw:lg:py-[80px]"
		>
			<h1 className="tw:sr-only">{companyName}</h1>
			{isContinueStep && (
				<div className="tw:relative tw:flex tw:w-full tw:max-w-full tw:flex-col tw:justify-between tw:md:flex-row tw:lg:max-w-[335px] tw:lg:flex-col tw:lg:justify-start tw:xl:max-w-[445px]">
					<MovingAssistance />
				</div>
			)}
			<div
				className={`tw:flex tw:flex-col ${isContinueStep ? "tw:w-full" : "tw:ml-auto tw:lg:w-[635px]"}`}
			>
				<div className="tw:relative tw:rounded-2xl tw:bg-white tw:px-4 tw:py-8 tw:shadow-[0px_8px_24px_0px_rgba(23,23,23,0.06)] tw:md:rounded-[32px] tw:md:p-10">
					{children}
				</div>
			</div>
		</Container>
	);
};

PostFormLayout.propTypes = {
	children: PropTypes.node,
};
